import React, { Component } from "react";
import { Button, Modal } from "antd";

export class BottomButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onChangeType = (type) => this.setState({ type });

  // deleteContract = (type) => {
  //   let title = '';
  //   let content = '';
  //   let func =()=>{};
  //   if(type === 'DELETE'){
  //     title = 'Xoá hợp đồng';
  //     content = 'Bạn có chắc chắn muốn xoá hợp đồng không? Nếu xoá mọi thông tin về hợp đồng trước đó sẽ không được lưu trong hệ thống.';
  //     func = apiContract.deleteContract;
  //   } else {
  //     func = apiContract.cancelContract;
  //     title = 'Huỷ hợp đồng';
  //     content = 'Bạn có chắc chắn muốn huỷ hợp đồng không? Nếu huỷ mọi thông tin về hợp đồng sẽ được kết thúc.';
  //   }
  //   Modal.confirm({
  //     title: title,
  //     icon: null,
  //     content: content,
  //     okText: 'Có',
  //     okType: 'danger',
  //     cancelText: 'Không',
  //     onOk:async ()=> {
  //       const { contractParam, close } = this.props;
  //       const result = await func(contractParam.id);
  //       if (result.status === 'success'){
  //         alert('success', `${title} thành công!`)
  //         close();
  //       } else {
  //         alert('error', result.data.message)
  //       }
  //     },
  //     onCancel() {
  //     },
  //     className: 'del-comfirm'
  //   })
  // }

  goBack = (isEditBack) => {
    let title = "Huỷ thao tác";
    let content =
      "Bạn có chắc chắn muốn quay lại? Nếu bạn quay lại mọi thông tin trước đó sẽ không được lưu.";
    const { cancelEdit, close } = this.props;
    Modal.confirm({
      title: title,
      icon: null,
      content: content,
      okText: "Có",
      okType: "danger",
      cancelText: "Không",
      onOk: () => {
        if (isEditBack) {
          cancelEdit();
        } else {
          close();
        }
      },
      onCancel() {},
      className: "del-comfirm",
    });
  };

  render() {
    const { submit, typeOption, close, enableEdit } = this.props;
    return (
      <div className="customer-container">
        {typeOption === "create_new" ? (
          <>
            <Button onClick={() => this.goBack()} className="cancel-btn">
              Huỷ
            </Button>
            <Button className="add-btn" onClick={submit}>
              Thêm khách hàng
            </Button>
          </>
        ) : typeOption === "show_detail" ? (
          <>
            <Button onClick={close} className="cancel-btn">
              Hủy
            </Button>
            <Button onClick={enableEdit} className="add-btn">
              Chỉnh sửa
            </Button>
          </>
        ) : (
          <>
            <Button onClick={() => this.goBack(true)} className="cancel-btn">
              Huỷ
            </Button>
            <Button className="add-btn" onClick={submit}>
              Lưu thay đổi
            </Button>
          </>
        )}
      </div>
    );
  }
}
